import React from 'react';
import { Item } from './item';

export const SelectItem = ({ products = [], isTablet, hasNiitaContract }) => {
  return (
    <section className="pt-8 w-full" id="products">
      {/* Header */}
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold font-sans text-slate-800 tracking-wider mb-1">SELECT ITEM</h3>
        <p className="text-xs text-slate-500 font-medium">Recommended Items（提案）</p>
        <div className="w-8 h-1 bg-primary mx-auto mt-3 rounded-full"></div>
      </div>

      {/* Products List */}
      <div className="space-y-4">
        {products.map((item, index) => (
          <Item key={index} data={item} hasNiitaContract={hasNiitaContract} />
        ))}
      </div>

      {/* Disclaimer */}
      <div className="px-2 pt-8 pb-4">
        <p className="text-[10px] text-slate-400 leading-relaxed text-justify bg-slate-100 p-3 rounded border border-slate-200">
          ※本判定結果は、ご提出いただいた検体および問診票に基づき分析を行ったものであり、医療機関による診断ではありません。異常を感じた場合は専門の医療機関を受診してください。
        </p>
      </div>
    </section>
  );
};
